import { colors, fontWeights } from "./";
var components = {
    headings: {
        h1: {
            fontSize: ['1.813rem', '2.625rem'],
            letterSpacing: ['0.04rem', '0.05rem'],
            fontWeight: fontWeights.bold,
            lineHeight: 1.2,
        },
        h2: {
            fontSize: ['1.375rem', '1.813rem'],
            letterSpacing: '1.81px',
            fontWeight: fontWeights.bold,
            lineHeight: 1.2,
        },
        h3: {
            fontSize: ['1.25rem', '1.375rem'],
            letterSpacing: '1.2px',
            fontWeight: fontWeights.bold,
            lineHeight: 1.2,
        },
        h4: {
            fontSize: ['1.125rem', '1.25rem'],
            letterSpacing: '0.05rem',
            fontWeight: fontWeights.bold,
            lineHeight: 1.2,
        },
        h5: {
            fontSize: ['1.125rem', '1.25rem'],
            letterSpacing: '0.05rem',
            fontWeight: fontWeights.bold,
            lineHeight: 1.2,
        },
        h6: {
            fontSize: ['1.125rem', '1.25rem'],
            letterSpacing: '0.05rem',
            fontWeight: fontWeights.bold,
            lineHeight: 1.2,
        },
    },
    cards: {
        backgroundColor: colors.white,
        boxShadow: '0 2px 24px 0 rgba(0, 0, 0, 0.12)',
        borderRadius: '10px',
        header: {
            color: '#222',
        },
        small: {
            padding: ['1rem 1rem', '1.5rem 1.5rem'],
        },
        medium: {
            padding: ['1.5rem 1.5rem', '2rem 2rem'],
        },
        large: {
            padding: ['2rem 2rem', '4rem', '4rem'],
        },
    },
    modal: {
        padding: ['48px 16px', '64px 48px', '56px'],
    },
    markdown: {
        text: {
            color: colors.primary,
            fontWeight: fontWeights.medium,
            letterSpacing: '0.05rem',
            lineHeight: 1.2,
            fontSize: ['1rem', '1.125rem'],
        },
        table: {
            border: "1px solid ".concat(colors.primary),
            padding: '0.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
        },
    },
};
export default components;
//# sourceMappingURL=components.js.map